import module from 'viaticos/module.js'
import template from './template.html'

export class ViaticosPagosListaComponent {
  results

  editar (item) {
    if (!item.pago.status_pagado) return

    this.results = this.results.filter((pago) => (item.folio !== pago.folio))
  }
}

module.component('viaticosPagosLista', {
  controller: ViaticosPagosListaComponent,
  template,
  bindings: {
    results: '<',
  },
})



// WEBPACK FOOTER //
// ./src/viaticos/components/pagos/lista/component.js